import type { ActorView } from "../../queries.ts";
import { safeExternalUrl } from "./rich-text.tsx";

export function actorLabel(actor: ActorView): string {
  return actor.displayName || actor.handle || actor.did;
}

export function actorHandle(actor: ActorView): string {
  return actor.handle ? `@${actor.handle}` : actor.did;
}

export function initial(value: string): string {
  return [...value.trim()][0]?.toLocaleUpperCase() || "?";
}

/** Avatar image, or the actor's initial when there is none. */
export function Avatar(actor: ActorView, className = "avatar"): Element {
  const url = actor.avatar && safeExternalUrl(actor.avatar);
  return url
    ? <img class={className} src={url} alt="" loading="lazy" />
    : <span class={className} aria-hidden="true">{initial(actorLabel(actor))}</span>;
}
